import type { PricingCampaignModel } from '@/shared/generated'

import { filter, propEq } from 'lodash/fp'

export const getGlobalPricingCampaignsByPcSet = (
	id: string,
	campaigns: PricingCampaignModel[]
) => filter(propEq('global_pc_set_id', id))(campaigns)
